<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />
    <v-layout fill-height>
      <v-flex xs12 pa-0>
        <location-table
          :data="table"
          :options="options"
          :table="table"
          :toolbarShow="false"
          @select=""
        />
      </v-flex>
    </v-layout>
    <device-bar
      :open="getDeviceBarOpen"
      modalMode
      :modalActive="getData"
      @update=""
      @load-devices=""
      @close="() => {this.$emit('close', getData)}"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import LocationTable from '@/nms/components/partials/scrolltable.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'

// Типы для данных
interface StatisticsModalData {
  getLinks?: (options?: any) => Promise<any[]>
  [key: string]: any
}

interface DeviceItem {
  $id?: string
  name?: string
  cls?: string
  device_type?: string
  consume?: any
  children?: DeviceItem[]
  [key: string]: any
}

interface TableRow {
  name?: string
  device_type?: string
  consume?: any
  $id?: string
  [key: string]: any
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface BarState {
  device: { open: boolean }
}

interface ActiveDevice {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'STATISTICS_MODAL',

  components: {
    loadingCircle,
    LocationTable,
    DeviceBar,
  },

  props: {
    data: {
      type: Object as () => StatisticsModalData,
      default: () => ({})
    },
  },

  data(): {
    loader: boolean
    devices: DeviceItem[]
    bar: BarState
    options: OptionsData
    filter: any | null
    search: string
    table: TableData
  } {
    return {
      loader: false,
      devices: [],
      bar: {
        device: { open: false },
      },
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          endpoint: { width: '40%' },
          check: { width: '20%' },
        },
      },
      filter: null,
      search: '',
      table: {
        columns: [
          {
            title: 'device',
            value: 'name',
            type: 'text',
            width: '50%'
          },
          {
            title: 'device_type',
            value: 'device_type',
            type: 'text',
            width: '30%'
          },
          {
            title: 'consume',
            value: 'consume',
            type: 'text',
            width: '20%'
          }
        ],
        rows: []
      },
    }
  },

  computed: {
    getDeviceBarOpen(): boolean {
      const dev = this.$store.state.devices.activeDevice as ActiveDevice | null
      this.bar.device.open = !!(dev && dev.$id)
      return this.bar.device.open
    },

    getData(): StatisticsModalData {
      return this.data
    },

    getTable(): StatisticsModalData {
      return this.table
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      this.loadDevices()
      this.reset()
      this.statusUnsubscribe('STATISTICS_MODAL')
    },

    async loadDevices(): Promise<void> {
      try {
        this.setLoader('loadDevices', true)
        console.log(this.$options.name, 'loadDevices getData', this.getData)
        const data$ = await this.getData.getLinks?.({ compute: 'is_used' })
        this.devices = []
        
        if (data$?.length) {
          data$.forEach((child: DeviceItem) => {
            if (child.cls === 'device') {
              this.devices.push(child)
            }
          })
        }
        
        this.setLoader('loadDevices', false)
        this.prepareTable()
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadDevices', err)
        this.setLoader('loadDevices', false)
        this.loader = false
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async prepareTable(): Promise<void> {
      try {
        if (this.devices.length) {
          this.loader = true
          
          this.devices.forEach((child: DeviceItem) => {
            const row$: TableRow = {
              name: child.name,
              device_type: child.device_type,
              consume: child.consume,
              $id: child.$id
            }
            this.table.rows.push(row$)
          })
          
          this.loader = false
          this.statusSubscribe(this.devices, 'STATISTICS_MODAL')
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'prepareTable', err)
        this.loader = false
      }
    },

    async statusSubscribe(arr: DeviceItem[], group: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      
      if (arr.length) {
        arr.forEach((item: DeviceItem) => {
          if (item.$id) {
            this.$store.dispatch('addStatusKey', item)
          }
        })
        await this.$bridge.subscribe(arr.map(obj => obj.$id))
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    reset(): void {
      this.table.rows = []
    }
  }
})
</script>

<style scoped lang="less">

</style>
